import styled from 'styled-components'
import { OUTLINE_COLOR, SITE_BLACK_COLOR } from '@CSSVars/colors'
import { BREAK_POINT_MD, BREAK_POINT_LG } from '@CSSVars/variables'
import Dropdown from 'Components/Dropdown/Dropdown'

export const _FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;

  .dropdownSlider > div {
    margin-right: 0px;
    height: 44px;
    width: 100%;

    .dropdown {
      top: 44px;
    }
  }

  .dropdownSlider:last-of-type {
    .dropdownCont {
      .dropdown {
        right: 0;
        left: unset;
      }
    }
  }

  button {
    height: 44px;
  }


  svg {
    top: 50% !important;
    transform: translateY(-50%) ;
  }

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    .dropdownSliderFullPage > div {
      margin-right: 0px;
      height: 44px;
    }
  }
  

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;

    .dropdownSliderFullPage > div {
      width: 100%;
      min-width: 0;
    }

    button {
      width: calc(100vw / 3 - 24px);

      & > div, 
      & > div > div, 
      & > div > div > div {
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
`

export const _DropdownSelectContainer = styled.div`
  position: relative;

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    .dropdownCont:has(div) {
      &:before {
        content: " ";
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,.5);
        z-index: 9999;
      }
    }
  }
`

export const _DropdownSelect = styled(Dropdown)`
  width: auto;
  min-width: 144px;
  max-width: 220px;
  padding-right: 36px;
  white-space: nowrap;

  .dropdown {
    display: flex;
    justify-content: space-around;
    width: auto;
  }

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    min-width: 30%;
    width: 100%;

    .dropdown {
      width: calc(100% - 32px);
      max-width: 343px;
      position: fixed;
      top: auto !important;
      left: 50%;
      bottom: 16px;
      transform: translateX(-50%);
      padding: 16px 0 !important;
      border-radius: 10px;
      border: 1px solid white;
      > div {
        line-height: 40px;
        margin: 20px 0;
        padding: 0;
        border: none;
        font-weight: 600;
      }
    }
  }
`


export const _BedTypeGrid = styled.div`
  display: grid;
  grid-auto-rows: 44px;
  grid-column-gap: 12px;
  grid-row-gap: 12px;
  grid-template-columns: repeat(${({ threeCol }) => (threeCol ? 3 : 2)}, auto);
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    grid-template-columns: repeat(2, auto) !important;
  }

`
export const _BedItemText = styled.span`
  line-height: 17px;
`

export const _BedItem = styled.button`
  padding: 0;
  border: 1px solid ${OUTLINE_COLOR};
  background-color: ${({ active }) => (active ? SITE_BLACK_COLOR : 'white')};
  width: 80px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${({ active }) => (active && `
    ${_BedItemText} {
      color: white;
      border: none;
    }
  `)};

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 150px;
  }
`

